import React, { useEffect, useRef, useState } from 'react';
import { DialogComponent, Inputs, Tables } from '../../../../Components';
import { TableActions } from '../../../../Enums';
import { GlobalHistory } from '../../../../Helper';
import headerData from './BillingPreviewHeaderData';
import {
  GetBranchBillingUsersDetails,
  GetBranchesBillingInfo,
} from '../../../../Services';
import { InvoicePreviewDialog } from '../Sections/InvoicePreviewDialog';
import { getActionTableWithPermissions } from './TableAction';
import { BranchUserDetails } from '../History/BranchUserDetails';
import { useTranslation } from 'react-i18next';

const dialogStateInitialState = {
  isLoading: false,
  isOpen: false,
  row: {},
};
export const BillingPreview = ({ parentTranslationPath, translationPath }) => {
  const { t } = useTranslation(parentTranslationPath);

  const [filter, setFilter] = useState({
    branchName: '',
    pageIndex: 1,
    pageSize: 25,
  });
  const [previewDialogState, setPreviewDialogState] = useState({
    isOpen: false,
    branchId: null,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [dialogState, setDialogState] = useState(dialogStateInitialState);
  const [branchUserDetails, setBranchUserDetails] = useState(null);
  const timerRef = useRef();
  const [data, setData] = useState({ result: [], totalCount: 0 });

  const actionsOptions = async (actionType, row, _index, _event) => {
    if (TableActions.account.key === actionType) {
      GlobalHistory.push(`/home/billing-users?branchId=${row.branchId}`);
    } else if (actionType === TableActions.PrintInvoice.key) {
      setPreviewDialogState({ isOpen: true, branchId: row.branchId });
    } else if (actionType === TableActions.users.key) {
      setDialogState({ isLoading: true, isOpen: true, row });
      const userDetails = await GetBranchBillingUsersDetails(row.branchId);
      setBranchUserDetails(userDetails);
      setDialogState((state) => ({ ...state, isLoading: false }));
    }
  };
  const onChange = (field, value) => {
    setFilter((filter) => ({ ...filter, [field]: value }));
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      getBranchesBillingInfo(value);
    }, 700);
  };
  const onUserTypeClick = (type) => {
    GlobalHistory.push(
      `/home/billing-users?branchId=${dialogState.row.branchId}&isCRM=${!!type}`
    );
    setDialogState(dialogStateInitialState);
  };
  const getBranchesBillingInfo = async (branchName) => {
    setIsLoading(true);
    const result = await GetBranchesBillingInfo({ ...filter, branchName });
    setData(result);
    setIsLoading(false);
  };
  useEffect(() => {
    getBranchesBillingInfo();
  }, []);
  return (
    <div className='pt-3'>
      <div className='w-25 pl-3'>
        <Inputs
          inputPlaceholder={'Search by branch name'}
          onInputChanged={(e) => onChange('branchName', e.target.value)}
          value={filter.branchName}
          idRef='search_input'
        />
      </div>
      <Tables
        isLoading={isLoading}
        headerData={headerData}
        data={data.result}
        defaultActions={getActionTableWithPermissions()}
        isWithFilter
        actionsOptions={{ onActionClicked: actionsOptions }}
        parentTranslationPath={parentTranslationPath}
        translationPath={translationPath}
        totalItems={data.totalCount}
        itemsPerPage={filter.pageSize}
        onPageIndexChanged={(index) => onChange('pageIndex', index + 1)}
        onPageSizeChanged={(index) => onChange('pageSize', index)}
        activePage={filter.pageIndex - 1}
      />
      {previewDialogState.isOpen && (
        <InvoicePreviewDialog
          isOpen={previewDialogState.isOpen}
          branchId={previewDialogState.branchId}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          isForHistory={false}
          onClose={() =>
            setPreviewDialogState({ isOpen: false, branchId: null })
          }
          mainTitleText={'preview-invoice'}
        />
      )}
      <DialogComponent
        isOpen={dialogState.isOpen}
        dialogTitle={t('user-details')}
        dialogContent={
          <BranchUserDetails
            userDetails={branchUserDetails}
            isLoading={dialogState.isLoading}
            onUserTypeClick={onUserTypeClick}
            parentTranslationPath={parentTranslationPath}
          />
        }
        saveType=''
        onCancelClicked={() =>
          setDialogState((state) => ({ ...state, isOpen: false }))
        }
        maxWidth='sm'
      />
    </div>
  );
};
